module.exports = "/static/assets/3093350d47951f7522e6358069c4a8b7.png";